import { AppSettingsApiService } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationService } from '@shared';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as AppSettingsActions from './app-settings.actions';

@Injectable()
export class AppSettingsEffects {
  private actions$ = inject(Actions);
  private appSettingsApi = inject(AppSettingsApiService);
  private notification = inject(NotificationService);

  loadSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppSettingsActions.loadSettings),
      switchMap(() =>
        this.appSettingsApi.findAll().pipe(
          map((settings) => AppSettingsActions.loadSettingsSuccess({ settings })),
          catchError((error: any) => {
            this.notification.error('admin.settings.load_error');
            return of(AppSettingsActions.loadSettingsFailure({
              error: error.message || 'Failed to load settings',
            }));
          }),
        ),
      ),
    ),
  );

  updateSetting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppSettingsActions.updateSetting),
      switchMap(({ key, value }) =>
        this.appSettingsApi.update(key, value).pipe(
          map((setting) => {
            this.notification.success('admin.settings.save_success');
            return AppSettingsActions.updateSettingSuccess({ setting });
          }),
          catchError((error: any) => {
            this.notification.error('admin.settings.save_error');
            return of(AppSettingsActions.updateSettingFailure({
              error: error.message || 'Failed to update setting',
            }));
          }),
        ),
      ),
    ),
  );

  reloadAfterUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppSettingsActions.updateSettingSuccess),
      map(() => AppSettingsActions.loadSettings()),
    ),
  );
}
